import 'ol-layerswitcher/dist/ol-layerswitcher.css';
import '../../scss/layercontrol.scss';
// import sync from 'ol-hashed';

// all controls 
import './controls/search'
import './controls/zoom'
